export default function (context, val) {
    let form = context.state;
    form.dateType = val.dateType;
    form.CurrencyId = val.CurrencyId;
    form.RequirementSumFrom = val.RequirementSumFrom;
    form.RequirementSumTo = val.RequirementSumTo;
    form.PayStates = val.PayStates;
    form.ContragentID = val.ContragentID;
    form.ContragentName = val.ContragentName;
    form.ContragentType = val.ContragentType;
    form.RegularPaymentTypeId = val.RegularPaymentTypeId;
    form.AccountNumber = val.AccountNumber;
    form.AgreementCode = val.AgreementCode;
    form.PaymentOperationID = val.PaymentOperationID;
    form.CategoryId = val.CategoryId;
    form.PaymentTypeId = val.PaymentTypeId;
    form.CashId = val.CashId;
    form.PaymentAccountId = val.PaymentAccountId;
    form.LatePayments = val.LatePayments;
    form.OnlyAccepted = val.OnlyAccepted;

    let dFrom = new Date(), dTo = new Date();
    switch (val.dateStep) {
        case 1:
            dFrom.setDate(dFrom.getDate() - val.dateInt);
            break;
        case 2:
            dFrom.setDate(dFrom.getDate() - val.dateInt * 7);
            break;
        case 3:
            dFrom.setMonth(dFrom.getMonth() - val.dateInt);
            if (val.dateRound) {
                dFrom.setDate(1);
            }
            break;
    }

    form.dates = [
        '' + (dFrom.getDate() > 9 ? '' : '0') + dFrom.getDate() + '.' + (dFrom.getMonth() > 8 ? '' : '0') + (dFrom.getMonth() + 1) + '.' + dFrom.getFullYear(),
        '' + (dTo.getDate() > 9 ? '' : '0') + dTo.getDate() + '.' + (dTo.getMonth() > 8 ? '' : '0') + (dTo.getMonth() + 1) + '.' + dTo.getFullYear()
    ];
    if (val.searchClick) {
        context.dispatch('finances/regulars/search', null, {root: true});
    }
}